export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              随时随地 · 移动吃瓜
            </h2>
            <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-6 max-w-[560px] lg:max-w-none">
              关注51吃瓜网址官方渠道，无论是通勤路上、午休间隙还是睡前刷屏，51今日吃瓜与51吃瓜最新内容随时随地触手可及，再也不怕错过任何一个爆款大瓜。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 rounded-full font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                关注我们
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-600 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-700 border border-primary-400/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-notification-3-line text-lg"></i>
                开启推送
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-5 border border-background-50/20">
              <div className="w-full aspect-[9/16] bg-background-50/20 rounded-lg flex items-center justify-center">
                <i className="ri-smartphone-line text-4xl text-background-50/60"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}